import { render, staticRenderFns } from "./Beds.vue?vue&type=template&id=f673939a"
import script from "./Beds.vue?vue&type=script&lang=js"
export * from "./Beds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports